export default __webpack_public_path__ + "static/media/big-saffron.9df29f5e.png";